var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-invalid-feedback',{attrs:{"state":_vm.localState}},[_vm._v(" "+_vm._s(typeof _vm.validationError === 'string' ? _vm.validationError : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }